// @flow

import React from "react";
import { localize } from "redux-i18n";
import { List } from "@components";

type Props = $Exact<{
  ...PropsFromLocalize,
}>;

class AbsenceMonitoringPromotion extends React.Component<Props> {
  get features() {
    return [
      {
        key: "attendance",
        value: this.props.t("ABSENCE_MONITORING_PROMOTION_ATTENDANCE"),
      },
      {
        key: "alerts",
        value: this.props.t("ABSENCE_MONITORING_PROMOTION_ALERTS"),
      },
      {
        key: "meetings",
        value: this.props.t("ABSENCE_MONITORING_PROMOTION_MEETINGS"),
      },
      {
        key: "management",
        value: this.props.t("ABSENCE_MONITORING_PROMOTION_MANAGEMENT"),
      },
      {
        key: "compliance",
        value: this.props.t("ABSENCE_MONITORING_PROMOTION_REPORTS_AND_COMPLIANCE"),
      },
      {
        key: "reports",
        value: this.props.t("ABSENCE_MONITORING_PROMOTION_EXTRA_REPORTS"),
      },
    ];
  }

  get benefits() {
    return [
      {
        key: "transparency",
        value: this.props.t("ABSENCE_MONITORING_PROMOTION_TRANSPARENCY"),
      },
      {
        key: "compliance",
        value: this.props.t("ABSENCE_MONITORING_PROMOTION_COMPLIANCE"),
      },
      {
        key: "treatment",
        value: this.props.t("ABSENCE_MONITORING_PROMOTION_TREATMENT"),
      },
      {
        key: "efficiency",
        value: this.props.t("ABSENCE_MONITORING_PROMOTION_EFFICIENCY"),
      },
    ];
  }

  render() {
    return (
      <div className="p-4 bg-grey rounded">
        <h4 className="mb-3">{this.props.t("UPGRADE_ACCOUNT")}</h4>
        <div className="d-flex">
          <div className="mr-5">
            <List list={this.features} title={this.props.t("FEATURES")} />
            <List list={this.benefits} title={this.props.t("BENEFITS")} />
          </div>
          <div>
            <img
              className="w-450-px h-300-px"
              src="/assets/img/absence-monitoring.jpeg"
              alt={this.props.t("ABSENCE_MONITORING_PROMOTION_ALT_TEXT")}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default localize()(AbsenceMonitoringPromotion);
